export default __webpack_public_path__ + "static/media/enviadomayorista.fff6ccc5.png";